import "./LandingPage.css";
import Navbar from "../../components/Navbar";
import Notification from "../../components/Notification";
import Hero from "./Hero";
import AboutSchool from "./AboutSchool";
import NewsSlider from "./NewsSlider";
import PartnerSlide from "./PartnerSlide";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
// import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import Footer from "../../components/Footer";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import Loader from "../../components/Loader";

const LandingPage = () => {
  //fetch hlavni stranky
  const { loading, error, data } = useFetch(
    `${config.api}/api/landing-page?populate[hero][populate]=*&populate[about][populate]=*`
  );

  const {
    loading: loadingSponsors,
    error: errorSponsors,
    data: dataSponsors,
  } = useFetch(`${config.api}/api/sponsors?populate[0]=logo`);

  // handle errors when fetching here due to the need to call the useFetch hook unconditionally
  // možné stavy při/po fetchi
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání stránky" />;

  if (loadingSponsors) return <Loader />;
  if (errorSponsors)
    return <DefaultPage message="Chyba při načítání sponzorů" />;

  //? test
  //? console.log("lp", data);
  //? console.log("eventy", dataEvents);
  //? console.log("sponsors", dataSponsors);

  //kontrola zdali nejsou bloky poskladane opacne -- vyvolalo by to chybu pri vkladani props komponentam (blocks[0] nebo blocks[1])
  const hero = data.data.hero;
  const about = data.data.about;
  if (hero === "error-switched-blocks" && about === "error-switched-blocks") {
    return <DefaultPage message="Prohozene bloky na hlavní stránce" />;
  } else {
  }

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div>
      <Navbar />
      <Notification />
      <Hero
        title={hero.Nadpis}
        text={hero.Text}
        links={hero.Odkazy}
        background={`${config.api}${hero.Pozadi.url}`}
      />
      {/* o skole */}
      <AboutSchool
        small_title={about.small_title}
        main_title={about.main_title}
        text={about.text}
        main_image={`${config.api}${about.main_image.url}`}
        secondary_image={`${config.api}${about.secondary_image.url}`}
        link={about.link}
      />

      {/* aktuality */}
      <div className="container-fluid background-color">
        <div className="section-divider"></div>
        <div className="container text-center section-header">
          <h3>{data.data.newsTitle}</h3>
          <h2>{data.data.attributes?.newsDescription}</h2>
        </div>
        <NewsSlider />
        <div className="section-divider mt-5"></div>
      </div>

      {/* cela tato cast se vyrendruje pouze pokud bude vic jak 5 sponsoru, jinak slider ztraci vyznam */}
      {dataSponsors.data.length >= 5 && (
        <div className="container-fluid background-white-max">
          <div className="container text-center section-header">
            <h3>{data.data.sponsorsTitle}</h3>
            <h2>{data.data.attributes?.sponsorsDescription}</h2>
          </div>
          <div className="position-relative text-center pb-3">
            <Splide
              options={{
                type: "loop",
                gap: "1px",
                drag: true,
                arrows: true,
                pagination: false,
                autoplay: true,
                pauseOnHover: false,
                interval: 2500,
                speed: 800,
                perPage: 5,
                perMove: 1,
                breakpoints: {
                  875: {
                    perPage: 1,
                  },
                  1250: {
                    perPage: 3,
                  },
                },
                // autoScroll: {
                //   pauseOnHover: false,
                //   pauseOnFocus: false,
                //   rewind: false,
                //   speed: 0.35,
                // },
              }}
              // extensions={{ AutoScroll }}
              aria-label="Partners"
            >
              {dataSponsors.data.map((sponsor) => (
                <SplideSlide key={sponsor.id}>
                  <div className="d-flex justify-content-center">
                    <PartnerSlide
                      url={sponsor.url}
                      logoPath={`${config.api}${sponsor.logo.url}`}
                    />
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};
export default LandingPage;
